import { writable, get } from 'svelte/store'

const projects = writable({})

export default {
    subscribe: projects.subscribe,
    get: () => get(projects),
    set: (dict) => { projects.set(dict) }
  }